export const icons = {
    objc: 'https://d4.alternativeto.net/_dfeVaaKO30UKkDMc6OPUFWCytaL23LxW1DVfJUANNQ/rs:fit:280:280:0/g:ce:0:0/exar:1/YWJzOi8vZGlzdC9pY29ucy9vYmplY3RpdmUtY185OTk3Ny5wbmc.png',
    swift: 'https://cdn-icons-png.flaticon.com/512/732/732250.png',
    java: 'https://upload.wikimedia.org/wikipedia/vi/3/30/Java_programming_language_logo.svg',
    rn: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg',
    flutter:
        'https://upload.wikimedia.org/wikipedia/commons/7/79/Flutter_logo.svg',
    git: 'https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg',
    ts: 'https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg',
    angular:
        'https://upload.wikimedia.org/wikipedia/commons/c/cf/Angular_full_color_logo.svg',
    azure: 'https://swimburger.net/media/ppnn3pcl/azure.png',
    ionic: 'https://logosandtypes.com/wp-content/uploads/2020/07/Ionic.png',
    figma:
        'https://cdn4.iconfinder.com/data/icons/logos-brands-in-colors/3000/figma-logo-512.png',
    js: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png',
    dart: 'https://upload.wikimedia.org/wikipedia/commons/7/7e/Dart-logo.png',
    apple:
        'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg',
    android:
        'https://upload.wikimedia.org/wikipedia/commons/d/d7/Android_robot.svg',
};